import licenseModule from '../../license.module';

export default licenseModule.component('licenseDeactivateDetail', {
    template: require('./licenseDeactivateDetail.component.html'),
    controller: ['entitlementConstants', licenseDeactivateDetailComponent],
    bindings: {
        onlyPerpetual: '<',
        subscriptionPremiumUserId: '<',
        subscriptionDeviceId: '<',
        perpetualDeviceId: '<',
        perpetualPremiumUserId: '<',
        callback: '&',
        name: '<'
    }
});

function licenseDeactivateDetailComponent(entitlementConstants) {
    var vm = this;
    vm.devicesLabel = entitlementConstants.devices;
    vm.platformUsersLabel = entitlementConstants.platformUsers;

    vm.$onInit = function() {
        vm.eula = false;
    };

    vm.eulaChange = function() {
        vm.callback({ value: { eula: vm.eula } });
    };
}



// WEBPACK FOOTER //
// ./modules/license/features/license-deactivate-detail/licenseDeactivateDetail.component.js